import TrProductCardCollection from './TrProductCardCollection.v2.2.js';
import TrScrollPaginationCollectionProducts from './TrScrollPaginationCollectionProducts.js';
import TrScrollPaginationSearch from './TrScrollPaginationSearch.js';
import SliderCollection from './TrSliderCollection.v4.js';
import TabCollection from './TrTabCollection.js';
import TrVideoPlayerCollection from './TrVideoPlayerCollection.js';
import CountryTextCollection from './trCountryTextSwitch.v2.1.js';

function main() {
	new TrProductCardCollection();
	new SliderCollection();
	new TrVideoPlayerCollection();
	new TabCollection();
	new TrScrollPaginationCollectionProducts();
	new TrScrollPaginationSearch();
	new CountryTextCollection();
}

document.addEventListener('DOMContentLoaded', main);

if (Shopify && Shopify.designMode) {
	document.addEventListener('shopify:section:load', main);
}
